import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const Intro = () => (
    <section id="tentang" className="relative scroll-mt-20 overflow-hidden bg-[#071B37] py-20 lg:py-28" data-testid="intro-section">
        <div className="gold-hairline absolute left-0 top-0 h-px w-full" />
        <div className="mx-auto max-w-3xl px-5 text-center lg:px-8">
            <Reveal>
                <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[#DDB56C]">Tentang Kelas</p>
                <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-testid="intro-heading">
                    Kenalan dengan Kelas{" "}
                    <span className="font-accent italic text-gold-gradient">KPR Anti Boncos!</span>
                </h2>
                <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-white/75 sm:text-lg">
                    Sebuah kelas online bersama Cici Developer yang membahas strategi memahami dan mengelola KPR secara lebih cerdas. Cocok untuk kamu yang sedang merencanakan pembelian rumah, mempersiapkan pengajuan KPR, atau ingin mengevaluasi KPR yang sedang berjalan.
                </p>
                <div className="mx-auto mt-8 max-w-2xl border-y border-[#DDB56C]/40 py-6">
                    <p className="font-accent text-lg font-medium italic leading-relaxed text-[#DDB56C] sm:text-xl">
                        “Bukan hanya teori. Kamu akan mempelajari perspektif praktis dari pengalaman di dunia properti.”
                    </p>
                </div>
                <a href="#materi" data-testid="intro-cta"
                    className="group mt-10 inline-flex items-center gap-2 rounded-full border border-[#DDB56C]/50 px-7 py-3.5 text-sm font-bold text-[#DDB56C] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#DDB56C] hover:text-[#071B37]">
                    Pelajari Materinya
                    <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={2} />
                </a>
            </Reveal>
        </div>
    </section>
);
